/**
 * Curated tree of in-app destinations for SOP step-editor use.
 *
 * Each node is either a leaf (has `path`) or a parent (has `children`).
 * Kept manually curated (vs auto-scanned) because SOPs deep-link to specific
 * subtabs that only make sense to reference by human-friendly labels.
 */
export const APP_ROUTES = [
  {
    label: "Me",
    children: [
      { label: "My dashboard — overview", path: "/app/me?tab=dashboard" },
      { label: "My dashboard — tasks", path: "/app/me?tab=tasks" },
      { label: "My dashboard — goals", path: "/app/me?tab=goals" },
      { label: "My dashboard — timesheet", path: "/app/me?tab=timesheet" },
      { label: "My dashboard — compliance", path: "/app/me?tab=compliance" },
      { label: "My dashboard — skills", path: "/app/me?tab=skills" },
      { label: "Helpdesk", path: "/app/helpdesk" },
      { label: "Huddles — today", path: "/app/huddles?tab=today" },
    ],
  },
  {
    label: "Workspace",
    children: [
      { label: "Bulletin board", path: "/app/bulletin" },
      { label: "Policies", path: "/app/policies" },
      { label: "SOPs", path: "/app/sops" },
      { label: "Onboarding kits & questionnaires", path: "/app/onboarding-kits" },
      { label: "Huddles — manage", path: "/app/huddles?tab=manage" },
      { label: "Company Q&A", path: "/app/company-qa" },
      { label: "Calendar", path: "/app/calendar" },
      { label: "Map", path: "/app/map" },
      { label: "Activity feed", path: "/app/activity" },
      { label: "Notifications", path: "/app/notifications" },
      { label: "Inbox (email)", path: "/app/inbox" },
    ],
  },
  {
    label: "CRM",
    children: [
      { label: "Leads", path: "/app/leads" },
      { label: "Accounts", path: "/app/accounts" },
      { label: "Prospecting", path: "/app/prospecting" },
      { label: "Voice Agents", path: "/app/voice-agents" },
      { label: "Voice Campaigns", path: "/app/voice-campaigns" },
      { label: "Marketing", path: "/app/marketing" },
      { label: "Clients — Dashboard", path: "/app/clients?tab=dashboard" },
      { label: "Clients — Clients list", path: "/app/clients?tab=clients" },
      { label: "Clients — Projects (all)", path: "/app/clients?tab=projects" },
      { label: "Clients — Brands (all)", path: "/app/clients?tab=brands" },
      { label: "Brands — Dashboard", path: "/app/brands?tab=dashboard" },
      { label: "Brands — Brands list", path: "/app/brands" },
      { label: "Brands — Library", path: "/app/brands?tab=library" },
      { label: "Sales", path: "/app/sales" },
    ],
  },
  {
    label: "Delivery",
    children: [
      { label: "Projects", path: "/app/projects" },
      { label: "Tasks", path: "/app/tasks" },
      { label: "Tasks Dashboard", path: "/app/tasks-dashboard" },
      { label: "Goals & OKRs", path: "/app/goals" },
      { label: "Meetings & Comms", path: "/app/meetings" },
      { label: "Packages — Dashboard", path: "/app/packages" },
      { label: "Packages — Planner", path: "/app/packages" },
      { label: "Packages — Activity master", path: "/app/packages" },
      { label: "Packages — Rate card", path: "/app/packages" },
      { label: "Packages — Baselines & profitability", path: "/app/packages" },
    ],
  },
  {
    label: "HRMS",
    children: [
      { label: "Employees", path: "/app/employees" },
      { label: "Timesheet — My day", path: "/app/timesheet" },
      { label: "Timesheet — Swimlane", path: "/app/timesheet" },
      { label: "Timesheet — Approvals", path: "/app/timesheet" },
      { label: "Attendance", path: "/app/attendance" },
      { label: "Leaves", path: "/app/leaves" },
      { label: "HR Dashboard", path: "/app/hr-dashboard" },
      { label: "Onboarding", path: "/app/onboarding" },
      { label: "Alumni portal", path: "/app/alumni" },
    ],
  },
  {
    label: "Finance",
    children: [
      { label: "Finance dashboard", path: "/app/finance" },
      { label: "Invoices", path: "/app/invoices" },
      { label: "Quotes", path: "/app/quotes" },
      { label: "Payments", path: "/app/payments" },
      { label: "Expenses", path: "/app/expenses" },
      { label: "Assets & depreciation", path: "/app/assets" },
      { label: "AR follow-ups", path: "/app/ar-followups" },
      { label: "Task billing", path: "/app/finance/task-billing" },
    ],
  },
  {
    label: "Admin",
    children: [
      { label: "Settings — General", path: "/app/settings?tab=general" },
      { label: "Settings — Review & AI", path: "/app/settings?tab=review" },
      { label: "Settings — Branding", path: "/app/settings?tab=branding" },
      { label: "Settings — Themes", path: "/app/settings?tab=themes" },
      { label: "Settings — Engagement", path: "/app/settings?tab=engagement" },
      { label: "Settings — Notifications", path: "/app/settings?tab=notifications" },
      { label: "Settings — Security", path: "/app/settings?tab=security" },
      { label: "Settings — Data & Danger", path: "/app/settings?tab=advanced" },
      { label: "Roles & permissions", path: "/app/roles" },
      { label: "Members", path: "/app/members" },
      { label: "Escalations", path: "/app/escalations" },
      { label: "Auto-response", path: "/app/auto-response" },
      { label: "Engagement widget", path: "/app/engagement-widget" },
    ],
  },
];

/** Flatten to leaves for the searchable combo-box. */
export function flattenAppRoutes() {
  const out = [];
  APP_ROUTES.forEach((group) => {
    (group.children || []).forEach((leaf) => {
      out.push({ ...leaf, group: group.label });
    });
  });
  return out;
}
